
module.exports = {
    myHost: {
       'host':'https://api.mohammadmainulislam.com',
    }
};
